var map = {
	"./Balance.svg": 65461,
	"./Charts.svg": 55824,
	"./Credit.svg": 45116,
	"./Unpaid-Order.svg": 47493,
	"./add.svg": 2846,
	"./addFriends.svg": 49163,
	"./addressLoad.svg": 4773,
	"./allsetting.svg": 88856,
	"./bell.svg": 55328,
	"./chart.svg": 25091,
	"./clipboard.svg": 26876,
	"./communication.svg": 62358,
	"./component.svg": 72282,
	"./cube.svg": 81670,
	"./dashboard.svg": 15023,
	"./documentation.svg": 95130,
	"./dollar.svg": 5422,
	"./edit.svg": 60265,
	"./email.svg": 26951,
	"./error.svg": 57423,
	"./excel.svg": 89154,
	"./exit-fullscreen.svg": 38113,
	"./eye-open.svg": 65746,
	"./eye.svg": 19483,
	"./face-black.svg": 83701,
	"./face.svg": 14293,
	"./facebook.svg": 85429,
	"./form.svg": 61861,
	"./guide 2.svg": 30410,
	"./guide.svg": 40389,
	"./ic_account.svg": 72189,
	"./ic_address_address.svg": 11759,
	"./ic_address_name.svg": 7681,
	"./ic_address_phone.svg": 64511,
	"./ic_balance.svg": 73621,
	"./ic_benefits.svg": 82858,
	"./ic_catagories.svg": 24564,
	"./ic_cents.svg": 61684,
	"./ic_commission.svg": 85970,
	"./ic_delete.svg": 19843,
	"./ic_down.svg": 32072,
	"./ic_email.svg": 89720,
	"./ic_export.svg": 42263,
	"./ic_invoice_download.svg": 18113,
	"./ic_messenger.svg": 48703,
	"./ic_method.svg": 90539,
	"./ic_pwd.svg": 59952,
	"./ic_record.svg": 13972,
	"./ic_record2.svg": 20523,
	"./ic_report.svg": 87825,
	"./ic_rules.svg": 15791,
	"./ic_screenshot.svg": 40817,
	"./ic_search.svg": 90219,
	"./ic_up.svg": 20983,
	"./ic_view details.svg": 70885,
	"./ic_warn-notice.svg": 80737,
	"./ic_warn.svg": 47767,
	"./ic_withdrawal.svg": 9320,
	"./icon.svg": 21714,
	"./income.svg": 55550,
	"./international.svg": 11014,
	"./inventory.svg": 64694,
	"./link.svg": 72146,
	"./linking.svg": 31189,
	"./list.svg": 85069,
	"./lock.svg": 54569,
	"./login.svg": 87026,
	"./logout.svg": 78389,
	"./message.svg": 38737,
	"./mseeage.svg": 68168,
	"./note.svg": 49907,
	"./orders.svg": 94652,
	"./password.svg": 46782,
	"./payoneer.svg": 12723,
	"./paypal.svg": 36113,
	"./pdf.svg": 22189,
	"./peoples.svg": 39422,
	"./pull.svg": 69635,
	"./relevance.svg": 308,
	"./search.svg": 86682,
	"./setting.svg": 63439,
	"./shippingcost.svg": 11187,
	"./shopcart.svg": 57684,
	"./shopping.svg": 71095,
	"./size.svg": 53503,
	"./sourcing.svg": 76467,
	"./star.svg": 79084,
	"./tab.svg": 54718,
	"./table.svg": 7496,
	"./theme.svg": 99030,
	"./transfer.svg": 54268,
	"./tree-table.svg": 58973,
	"./tree.svg": 62241,
	"./triangle.svg": 90779,
	"./trophy.svg": 60635,
	"./unrelevance.svg": 65636,
	"./user.svg": 87980,
	"./wallet.svg": 43942
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87886;